module.exports = __webpack_public_path__ + "img/4.17ddf151.svg";